export function newUpdateText() {
  return "47 brand new locations added for Sailing!!";
}
